export enum TransactionItemType {
Good,
Service,
Other,
Asset,
}
